import template from './secureAeriesConnection.html';
import controller from './secureAeriesConnection.controller';

let secureAeriesConnectionComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default secureAeriesConnectionComponent;



// WEBPACK FOOTER //
// ./app/components/secureAeriesConnection/secureAeriesConnection.component.js